// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SetDirectionOfFeeSelect: 'set-direction-of-fee-select',
	FeeDirectionOption: 'fee-direction-option',
} as const;
